<template>
	<div
		:class="{ 'p-5': some_condition_passes }"
		v-if="!props.class_canceled && !props.class_closed_with_pending">
		<div
			class="d-flex flex-column flex-center flex-column-fluid my-2"
			v-if="props.class_ready">
			<div class="d-flex flex-column flex-center text-center p-10">
				<div class="card card-flush w-md-650px py-5">
					<div class="card-body">
						<div class="mb-7">
							<img
								src="/icons/meeting-alerts/success-icon.png"
								class="h-40px" />
						</div>
						<h1
							class="fw-bolder text-gray-900"
							style="font-size: 30px">
							Olá, {{ name }}!
						</h1>
						<div class="fw-bolder fs-3 text-gray-500 mb-5">
							Você chegou cedo à nossa Sala de Aula Virtual. Fique
							tranquilo(a), a aula começará em breve.
						</div>

						<div
							id="starting_class"
							class="notice d-flex bg-light-warning rounded border-warning border border-dashed m-10 p-5"
							v-if="
								props.student_registered_in_class &&
								props.starting_class
							">
							<div class="d-flex flex-stack flex-grow-1">
								<div class="fw-semibold">
									<h4 class="text-gray-900 fw-bold">
										Antes de começar a aula é necessario
										validar a biometria.
									</h4>
									<div class="fs-6 text-gray-700">
										De acordo com a normativa do Detran, o
										sistema mantém sua webcam ligada e pode
										tirar fotos durante a aula.
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="d-flex flex-column flex-center flex-column-fluid m-2"
			v-if="props.class_finished">
			<div class="d-flex flex-column flex-center text-center p-10">
				<div class="card card-flush w-md-650px py-5">
					<div class="card-body">
						<div class="mb-7">
							<img
								src="/icons/meeting-alerts/success-icon.png"
								class="h-40px" />
						</div>
						<h1
							class="fw-bolder text-gray-900"
							style="font-size: 30px">
							Parabéns !
						</h1>
						<div class="fw-bolder fs-3 text-gray-500">
							Aula finalizada com sucesso.
						</div>

						<div
							class="notice d-flex bg-light-warning rounded border-warning border border-dashed m-10 p-5">
							<div class="d-flex flex-stack flex-grow-1">
								<div class="fw-semibold">
									<h4 class="text-gray-900 fw-bold">
										Protocolo de finalização:
										{{ props.user_registrant_id }} - {{ props.date_protocol }}
									</h4>
									<div class="d-flex position-relative mb-5">
										<div class="position-absolute top-0 start-0 rounded h-100 bg-secondary w-4px"></div>
										<div class="fw-semibold ms-5">
											<p class="fs-5 fw-bold text-gray-900 text-start m-0"> Informações do Aluno</p>
											<p class="text-start m-0"><strong>Nome:</strong> {{ props.student_name }}</p>
											<p class="text-start m-0"><strong>CPF:</strong> {{ props.student_cpf }}</p>
										</div>
									</div>
									<div class="fs-6 text-gray-700">
										Entre em contato pelo chat e informe o
										código em caso de dúvida.
										<br />
										<a
											class="fw-bold"
											href="https://tawk.to/chat/625712c2b0d10b6f3e6d6cfc/1g0i22iep"
											>Suporte</a
										>
									</div>
								</div>
							</div>
						</div>

						<div class="mb-0">
							<a href="/dashboard" class="btn btn-sm btn-primary"
								>Voltar para a Home</a
							>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-else-if="props.time_is_over_class || props.failed_to_open_class">
			<infoClass
				:user_registrant="props.user_registrant"
				:class_start_at="props.class_start_at"
				:class_deadline_formated="props.class_deadline_formated"
			/>
			<div
				class="d-flex flex-column flex-center flex-column-fluid m-2"
				v-if="props.failed_to_open_class">
				<div class="d-flex flex-column flex-center text-center p-10">
					<div class="card card-flush w-md-650px">
						<div class="card-body">
							<div class="mb-7">
								<img
									src="/icons/meeting-alerts/error-icon.png"
									class="h-40px" />
							</div>
							<h1
								class="fw-bolder text-gray-900 mb-4"
								style="font-size: 30px">
								Tempo para abertura de aula excedido !
							</h1>
							<div class="fw-bolder fs-3 text-gray-500 mb-4">
								A sua aula estava agendada para
								{{ class_start_at }} com o tempo de tolerância conforme informado pelo seu CFC.
							</div>
							<div class="card-footer mb-0">
								<span class="text-muted fw-bolder fs-6"
									>Verifique com seu instrutor para reagendar
									sua aula!</span
								>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				class="d-flex flex-column flex-center flex-column-fluid my-2"
				v-if="props.time_is_over_class">
				<div class="d-flex flex-column flex-center text-center p-md-10">
					<div class="card card-flush w-md-650px">
						<div class="card-body row">
							<div class="mb-7">
								<img
									src="/icons/meeting-alerts/error-icon.png"
									class="h-40px" />
							</div>
							<div
								class="fw-bolder fs-3 text-gray-500 mb-5 col-md-12"
								v-if="!closed_before_students_waiting_time">
								Você precisará refazer sua aula, tempo para fechamento de aula excedido!
								Infelizmente, o DETRAN determina que o aluno
								tenha apenas
								{{ props.additional_minutes_to_close_class }}
								minutos após o horário limite para finalizar a
								aula.
							</div>
							<div
								class="fw-bolder fs-5 text-gray-500 mb-5"
								v-else>
								<p>
									Horário que o instrutor finalizou a aula:
									{{
										new Date(
											closed_before_students_waiting_time
										).toLocaleString()
									}}
								</p>
							</div>
							<div class="card-footer mb-0">
								<span class="text-muted fw-bolder fs-6"
									>Verifique com seu instrutor para reagendar
									sua aula!</span
								>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

        <div class="d-flex flex-column flex-center flex-column-fluid"
            v-if="props.ban">
            <div class="d-flex flex-column flex-center text-center p-10">
                <div class="card card-flush w-md-650px">
                    <div class="card-body">
                        <div class="mb-7">
                            <img src="/icons/meeting-alerts/error-icon.png" class="h-40px" />
                        </div>
                        <h1
                            class="fw-bolder text-gray-900 mb-4"
                            style="font-size: 30px">
                            Você foi banido desta aula!
                        </h1>
                        <div class="fw-bolder fs-3 text-gray-500 mb-4">
                            <p>Por: {{props.ban.created_by.name}}</p>
                            <p>Motivo: {{props.ban.reason}}</p>
                        </div>
                        <div class="card-footer mb-0">
                            <span class="text-muted fw-bolder fs-6">
                                Verifique com seu instrutor para reagendar sua aula!
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script lang="ts" setup>
	import { computed } from '@vue/reactivity';
	import { PropType } from 'vue';
	import { ClassBan } from '../../Interfaces/ClassBan';
	import infoClass from '../Student/info_class.vue';
	import { UserRegistrant } from 'resources/js/Interfaces/UserRegistrant';

	const props = defineProps({
		student_registered_in_class: { type: Boolean, required: true },
		starting_class: { type: Boolean, required: true },
		class_finished: { type: Boolean, required: true },
		class_ready: { type: Boolean, required: true },
		class_canceled: { type: Boolean, required: true },
		time_is_over_class: { type: Boolean, required: true },
		failed_to_open_class: { type: Boolean, required: true },
		class_closed_with_pending: { type: Boolean, required: true },
		student_in_class: { type: Boolean, required: true },
		haveMeet: { type: Boolean, required: true },
		student_name: { type: String, required: true },
		student_cpf: { type: String, required: true },
		user_registrant_id: { type: Number, required: true },
		class_start_at: { type: String, required: true },
		additional_minutes_to_open_class: { type: Number, required: true },
		additional_minutes_to_close_class: { type: Number, required: true },
		closed_before_students_waiting_time: { type: String, required: false },
		date_protocol: { type: String, required: true },
		ban: {type: Object as PropType<ClassBan>, required: false},
		user_registrant: {type: Object as PropType<UserRegistrant>, required: true},
		class_deadline_formated: {type: String, required: true},
	});

	const name =
		props.student_name.charAt(0).toUpperCase() +
		props.student_name.slice(1).toLocaleLowerCase().split(' ')[0].trim();

	const some_condition_passes = computed(() => {
		return (
			(props.class_ready && !props.haveMeet) ||
			(props.student_registered_in_class && props.starting_class) ||
			props.time_is_over_class ||
			props.class_finished ||
			props.failed_to_open_class
		);
	});
</script>
